import PropTypes from "prop-types";
import Photo from "components/shared/stays/Photo";
import styles from "components/stay/HeroPhoto.module.scss";

/**
 * @param {object} photo - Photo object
 */

export default function HeroPhoto({ photo }) {
  return (
    <div className={styles.visual}>
      <div className={styles.wrapper}>
        {photo && (
          <Photo
            src={photo.url}
            alt="Hero"
            layout="fill"
            objectFit="cover"
            placeholder
            priority
          />
        )}
      </div>
    </div>
  );
}

HeroPhoto.propTypes = {
  photo: PropTypes.shape({
    url: PropTypes.string,
    content_type: PropTypes.string,
    byte_size: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
};
